import React from "react";
const CourseRight = ({ course }) => {
    return (
        <>
           {/* <div className="course-right">
               <ul className="list-unstyled course-ul-right">
                    <li><i className="bi bi-calendar3"></i> 1 Year Access</li>
                    <li><i className="bi bi-bar-chart"></i> Level 5</li>
                    <li><i className="bi bi-people"></i> 2987 Students</li>
                    <li><i className="bi bi-clock"></i> 1 week, 6 days</li>
               </ul>
           </div> */}

           <div className="side-box">
                <h5 className="side-box-title">🧠 Course Learning Outcomes (Why This Course Matters)</h5>
                <p><strong>Importance of the Course</strong></p>
                <div className="side-box-con">
                    <p dangerouslySetInnerHTML={{ __html: course?.course_learning_outcomes }} />
                </div>
           </div>
           <div className="side-box">
                <h5 className="side-box-title">🚀 Key Benefits</h5>
                <div className="side-box-con">
                    <p dangerouslySetInnerHTML={{ __html: course?.key_benefits }} />
                </div>
           </div>
           <div className="side-box">
                <h5 className="side-box-title">📈 Career Impact</h5>
                <div className="side-box-con">
                     <p dangerouslySetInnerHTML={{ __html: course?.career_impact }} />
                </div>
           </div>
        </>

    );
};

export default CourseRight;